import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from '@emotion/react';
import { createTheme, CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import ConfigureStore from './stores/store';
import PrivateRoute from './services/PrivateRoute';
import UserProfilePage from './PrivateSide/pages/userProfilePage/UserProfilePage';
import UserManagementPage from './PrivateSide/pages/managementPage/UserManagementPage';
import ServersPage from './PrivateSide/pages/serversPage/ServersPage';
import VersionHistoryPage from './PrivateSide/pages/versionsPage/VersionHistoryPage';
import DefinePasswordPage from './PrivateSide/pages/definePasswordPage/DefinePasswordPage';
import MessagesInPage from './components/bases/MessagesInPage';
import ErrorPage from './PublicSide/pages/errorPage/ErrorPage';
import LegalInformation from './PublicSide/pages/legalInformation/LegalInformation';
import PrivacyPolicy from './PublicSide/pages/privacyPolicy/PrivacyPolicy';
import LoginPage from './PrivateSide/pages/loginPage/LoginPage';
import DashboardPage from './PrivateSide/pages/dashboardPage/DashboardPage';
import HomePage from './PublicSide/pages/homePage/HomePage';

const store = ConfigureStore();

const theme = createTheme({
  palette: {
    background: {
      default: '#1C1D2B',
    },
    text: {
      primary: '#FFFFFF',
    },
  },
  typography: {
    h1: {
      fontFamily: 'Fredoka, sans-serif',
      fontWeight: 600,
      fontSize: '26px',
    },
    h2: {
      fontFamily: 'Fredoka, sans-serif',
      fontWeight: 600,
      fontSize: '22px',
      letterSpacing: '1.5px',
    },
    h3: {
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 600,
      fontSize: '18px',
    },
    body2: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '14px',
      fontWeight: 400,
    },
    body1: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '14px',
    },
  },
});

const App: React.FC = () => (
  <Provider store={store.store}>
    <PersistGate loading={null} persistor={store.persistor}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Routes>
            <Route path='*' element={<ErrorPage />} />
            <Route path='/' element={<HomePage />} />
            <Route path='/legal_information' element={<LegalInformation />} />
            <Route path='/privacy_policy' element={<PrivacyPolicy />} />
            <Route path='/login' element={<LoginPage />} />
            <Route path='/password' element={<DefinePasswordPage />} />
            <Route path='/dashboard' element={<PrivateRoute element={<DashboardPage />} />} />
            <Route path='/profile' element={<PrivateRoute element={<UserProfilePage />} />} />
            <Route path='/management' element={<PrivateRoute element={<UserManagementPage />} />} />
            <Route path='/application/:applicationId/servers' element={<PrivateRoute element={<ServersPage />} />} />
            <Route path='/application/:applicationId/addServer' element={<PrivateRoute element={<DashboardPage />} />} />
            <Route path='/applications/:applicationId/versions' element={<PrivateRoute element={<VersionHistoryPage />} />} />
            <Route path='/guns-of-glory' element={<PrivateRoute element={<DashboardPage />} />} />
            <Route path='/misty-continent' element={<PrivateRoute element={<DashboardPage />} />} />
            <Route path='/stormshot' element={<PrivateRoute element={<DashboardPage />} />} />
          </Routes>
        </Router>
        <MessagesInPage />
      </ThemeProvider>
    </PersistGate>
  </Provider>
);

export default App;
